module.exports = __webpack_public_path__ + "static/img/logo1.5c8a29f.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo1.png
// module id = wx7f
// module chunks = 1